import { ThemeProvider } from 'styled-components';

import { ThemeTypes } from 'Types/enums';

import { lightTheme } from './lightTheme';
import { darkTheme } from './darkTheme';
import { ThemeColor } from '../types/ThemeContextProps';

export const StyledProvider = ({ 
  theme,
  mobile,
  children
}:{
  theme     : ThemeColor,
  mobile    : boolean,
  children  : any
}) => {

  return (
    <ThemeProvider
      theme   = {{
        mobile,
        ...(theme === ThemeTypes.LIGHT ? lightTheme : darkTheme)
      }}
    >
      {children}
    </ThemeProvider>
  );

}